export const HealthFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.1 22.5c5.799 0 10.5-4.701 10.5-10.5S17.899 1.5 12.1 1.5 1.6 6.201 1.6 12s4.7 10.5 10.5 10.5m0-16.4a5.5 5.5 0 0 0-2.243.48A5.9 5.9 0 0 0 7.943 7.96a6.5 6.5 0 0 0-1.288 2.078A6.9 6.9 0 0 0 6.2 12.5v.6H5v-.6c0-.992.181-1.975.535-2.894a7.7 7.7 0 0 1 1.529-2.464 7.1 7.1 0 0 1 2.304-1.657A6.7 6.7 0 0 1 12.1 4.9a6.7 6.7 0 0 1 2.732.585 7.1 7.1 0 0 1 2.304 1.657 7.7 7.7 0 0 1 1.529 2.464c.353.919.535 1.902.535 2.894v.6H18v-.6c0-.846-.155-1.684-.455-2.463a6.5 6.5 0 0 0-1.289-2.078 5.9 5.9 0 0 0-1.913-1.378A5.5 5.5 0 0 0 12.1 6.1m-.854 6.046 3-3 .707.708-3 3a.5.5 0 1 1-.707-.708"
      clipRule="evenodd"
    ></path>
  </svg>
);
